// src/assets/icons/index.js

import { ReactComponent as ClientInsightsIcon } from "./client-insights.svg";
import { ReactComponent as IncreasedEfficiencyIcon } from "./increased-efficiency.svg";
import { ReactComponent as ProcessAutomationIcon } from "./process-automation.svg";
import { ReactComponent as DataDrivenInnovationIcon } from "./data_driven-innovation.svg";
import { ReactComponent as ReducedCostsIcon } from "./reduced-costs.svg";
import { ReactComponent as MarketInsightsIcon } from "./market-insights.svg";
import { ReactComponent as BigDataConsultingIcon } from "./big-data-consulting.svg";
import { ReactComponent as DataInfrastructureEngineeringIcon } from "./data-infrastructure-engineering.svg";
import { ReactComponent as DataAnalyticsIcon } from "./icon-data-analytics.svg";
import { ReactComponent as DataVisualizationIcon } from "./icon-data-visualization.svg";
import { ReactComponent as LinkedinIcon } from "./linkedin-icon.svg";
import { ReactComponent as BiDataViewIcon } from "./bi-data-view.svg";
import { ReactComponent as AppDevelopmentIcon } from "./app-development.svg";
import { ReactComponent as MachineLearningIcon } from "./machine-learnig.svg";
import { ReactComponent as DataEngineeringIcon } from "./engenharia-dados.svg";
import { ReactComponent as LogoIcon } from "./logo-black.svg";
import { ReactComponent as LogoSemMolduraIcon } from "../logo sem moldura.svg";

import { ReactComponent as TomadaDecisaoInteligente } from "./benefits/take-inteligence-decision.svg";
import { ReactComponent as AltaPerformance } from "./benefits/alta performance.svg";
import { ReactComponent as EficienciaOperacional } from "./benefits/operational-eficiency.svg";
import { ReactComponent as InovacaoTecnologica } from "./benefits/inovation.svg";
import { ReactComponent as SegurancaInformacao } from "./benefits/information-security.svg";
import { ReactComponent as ConformidadeRegulatoria } from "./benefits/terms.svg";
import { ReactComponent as Desenvolvimento } from "./desenvolvimento.svg";
import { ReactComponent as AltaDisponibilidade } from "./benefits/Alta disponibilidade.svg";
import { ReactComponent as Continuidade } from "./benefits/continuidade.svg";

const icons = {
  "client-insights": ClientInsightsIcon,
  "increased-efficiency": IncreasedEfficiencyIcon,
  "process-automation": ProcessAutomationIcon,
  "data-driven-innovation": DataDrivenInnovationIcon,
  "reduced-costs": ReducedCostsIcon,
  "market-insights": MarketInsightsIcon,
  "big-data-consulting": BigDataConsultingIcon,
  "data-infrastructure-engineering": DataInfrastructureEngineeringIcon,
  "data-analytics": DataAnalyticsIcon,
  "data-visualization": DataVisualizationIcon,
  linkedin: LinkedinIcon,
  "bi-data-view-icon": BiDataViewIcon,
  "data-engineering": DataEngineeringIcon,
  "app-development": AppDevelopmentIcon,
  "machine-learning": MachineLearningIcon,
  LogoIcon,
  LogoSemMolduraIcon,
  TomadaDecisaoInteligente,
  AltaPerformance,
  EficienciaOperacional,
  InovacaoTecnologica,
  SegurancaInformacao,
  ConformidadeRegulatoria,
  Desenvolvimento,
  AltaDisponibilidade,
  Continuidade,
};

export default icons;
